import { render, staticRenderFns } from "./SupportTicket.vue?vue&type=template&id=278c5e7e&scoped=true&"
import script from "./SupportTicket.vue?vue&type=script&lang=js&"
export * from "./SupportTicket.vue?vue&type=script&lang=js&"
import style0 from "./SupportTicket.vue?vue&type=style&index=0&id=278c5e7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278c5e7e",
  null
  
)

export default component.exports